import { MenuItemSaleUnit } from './menu_item_sale_unit.js';

export function name(saleUnit: MenuItemSaleUnit): string {
  switch (saleUnit) {
    case MenuItemSaleUnit.Each:
      return 'Each';
    case MenuItemSaleUnit.LB:
      return 'Pounds';
    case MenuItemSaleUnit.OZ:
      return 'Ounces';
  }
}

export function notation(saleUnit: MenuItemSaleUnit | undefined): string {
  if (typeof saleUnit === 'undefined') {
    return '';
  }

  switch (saleUnit) {
    case MenuItemSaleUnit.Each:
      return '';
    case MenuItemSaleUnit.LB:
      return 'lb';
    case MenuItemSaleUnit.OZ:
      return 'oz';
  }
}
